import { statusLabel } from "../lib/format";

export function StatusBadge({ status }: { status?: string }) {
  const normalized = (status || "").toUpperCase();
  const tone = ["RECEBIDO", "PAGO", "CONCLUIDO", "CONCLUIDA", "ATIVO", "ASSINADO", "EMITIDA", "CONECTADO"].includes(normalized)
    ? "success"
    : ["VENCIDO", "SUSPENSO", "INATIVO", "ATRASADA", "COM_ERRO", "ERRO", "AGUARDANDO_CORRECAO"].includes(normalized)
      ? "danger"
      : ["PENDENTE", "PARCIAL", "PROXIMO", "EM_ELABORACAO", "A_EMITIR", "AGUARDANDO_CLASSIFICACAO", "AGUARDANDO_FECHAMENTO", "EM_PREPARACAO", "EMITIDA_PARCIALMENTE", "EM_CONFERENCIA", "PRONTA_PARA_EMISSAO", "EM_EMISSAO", "REABERTA"].includes(normalized)
        ? "warning"
        : ["CANCELADO", "CANCELADA"].includes(normalized) ? "neutral" : "info";
  return <span className={`status status-${tone}`}>{statusLabel(status)}</span>;
}
